import { useState, useRef } from 'react';
import { cs_qrcode } from '@/utils/common';
import { Button } from '@/components/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover';
import { Drawer, DrawerContent, DrawerTrigger, DrawerTitle } from '@/components/drawer';
import { useDeviceType } from '@/hooks/useDeviceType';

interface CustomerButtonProps {
  text?: string;
  className?: string;
  size?: 'lgg' | 'lg' | 'default' | 'sm' | 'icon';
}

export const CustomerButton = ({
  text = '获取更多金币',
  className,
  size = 'lgg'
}: CustomerButtonProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { is_mobile } = useDeviceType();
  const popoverRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (is_mobile) {
      setIsDrawerOpen(true);
    } else {
      setIsPopoverOpen(true);
    }
  };

  const handleMouseEnter = () => {
    if (!is_mobile) {
      setIsPopoverOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!is_mobile) {
      setIsPopoverOpen(false);
    }
  };

  if (is_mobile) {
    return (
      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerTrigger asChild>
          <Button
            variant='primary'
            size={size}
            className={className}
            onClick={handleClick}
          >
            {text}
          </Button>
        </DrawerTrigger>
        <DrawerContent className="h-auto" overlayStyle={{ zIndex: 9998 }} style={{ zIndex: 9999 }}>
          <DrawerTitle className="sr-only">微信客服二维码</DrawerTitle>
          <div className="mx-auto w-full max-w-sm">
            <div className="px-4 pb-8">
              <div className="flex justify-center">
                <img
                  src={cs_qrcode}
                  alt="微信客服二维码"
                  className="w-64 h-64 object-cover rounded-lg"
                />
              </div>
              <p className="text-center text-sm text-gray-600 mt-4">
                微信扫码联系客服获取更多帮助
              </p>
            </div>
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <div ref={popoverRef}>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <Button
            variant='primary'
            size={size}
            className={className}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {text}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          container={popoverRef.current}
          className="w-fit h-fit rounded-[16px] p-[16px]"
          side="bottom"
          sideOffset={10}
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
        >
          <div className="text-center">
            <img
              src={cs_qrcode}
              alt="微信客服二维码"
              className="w-[10.8rem] h-[10.8rem] object-cover mb-2"
            />
            <p className="text-sm text-gray-600">
              微信扫码联系客服
            </p>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
